export default __webpack_public_path__ + "static/media/logo_black.2336fdd7.png";